<template>
<div class="chapter">
<div class="inner_page">
<div id="little-movien">
<div class="generated-style">
<p class="content" id="toc-anchor">Contents</p>
<p class="paragraph-1"><a href="#/little_07" style="text-decoration: none">Introduction</a></p>
<p class="paragraph-1"><a href="#/little_08" style="text-decoration: none">Glossary Entries</a></p>
<p class="paragraph-1">Appendices</p>
<p class="paragraph-1"><span href="#/little_09" style="text-decoration: none" title="Link target outside of Sample">Things You Would Never Know<br/> without the Movies</span></p>
<p class="paragraph-1"><span href="#/little_10" style="text-decoration: none" title="Link target outside of Sample">Mark O’Donnell’s <br/>Laws of Cartoon Motion</span></p>
<p class="paragraph-1"><span href="#/little_11" style="text-decoration: none" title="Link target outside of Sample">Greg Matty’s <br/>Creature Ferocity Index</span></p>
<p class="paragraph-1"><span href="#/little_12" style="text-decoration: none" title="Link target outside of Sample">A Cynic’s Guide to the Language <br/>in Film Festival Catalog Descriptions<br/> by Doug Saunders</span></p>
</div>
<div class="generated-style">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// little_06.vue?16881b50